import React from 'react';
import ErrorPage from './ErrorPage';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  FallbackComponent?: React.FC<{ message?: string }>;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Log error to monitoring service if needed
    // console.error(error, errorInfo);
  }

  render() {
    const { hasError, error } = this.state;
    const Fallback = this.props.FallbackComponent || ErrorPage;
    if (hasError) {
      return <Fallback message={error?.message} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary; 